import { PlusIcon } from 'lucide-react';

import { AvatarWithInitials } from '@eluve/blocks';
import { Badge, Box, Tag, legacyTextStyles } from '@eluve/components';

import { PatientOptionInfo, getName, getPatientDetails } from './utils';

export const PatientOption: React.FC<PatientOptionInfo & { new?: boolean }> = (
  patient,
) => {
  const name = getName(patient);
  const patientDetails = getPatientDetails(patient);

  return (
    <Box hStack className="gap-4 py-1">
      <AvatarWithInitials name={name} id={patient.id} />
      <Box vStack className="w-full flex-1">
        <span className="font-semibold text-text-secondary privacy-text">
          {name}
        </span>
        {patientDetails && (
          <Tag
            color="gray"
            label={patientDetails}
            size="xs"
            className={legacyTextStyles.body({
              color: 'primary',
              size: 's',
            })}
          />
        )}
        {patient.new && (
          <Badge className="w-max">
            <PlusIcon className="mr-1 size-4" />
            Create New
          </Badge>
        )}
      </Box>
    </Box>
  );
};
